<template>
  <div class="zoya-bubble" :class="placement ? 'is-' + placement : ''">
    <img class="zoya-bubble__avatar" src="/Zoya_avatar_2_small.jpg" alt="" width="40" height="40">
    <slot />
    <span v-if="placement" class="zoya-bubble__tail" aria-hidden="true" />
  </div>
</template>

<script setup>
defineProps({ placement: { type: String, default: '' } })
</script>

<style scoped>
.zoya-bubble {
  position: relative;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 10px 12px 12px 28px;
  box-shadow: 0 8px 22px rgb(var(--ink-rgb) / .14);
  font-family: Inter, sans-serif;
  font-size: var(--fs-14);
  line-height: 1.4;
  color: var(--ink);
}
.zoya-bubble__avatar {
  position: absolute; left: -16px; bottom: -12px;
  width: 40px; height: 40px; border-radius: 50%; object-fit: cover;
  border: 2px solid #fff; box-shadow: 0 2px 8px rgb(var(--ink-rgb) / .2);
}
.zoya-bubble__tail {
  position: absolute; left: calc(var(--tail-x, 50%) - 6px);
  width: 12px; height: 12px; background: #fff;
  border-right: 1px solid var(--line); border-bottom: 1px solid var(--line);
}
.is-above .zoya-bubble__tail { bottom: -7px; transform: rotate(45deg); }
.is-below .zoya-bubble__tail { top: -7px; transform: rotate(-135deg); }
</style>
